import React from "react";
// react plugin for creating charts
// react plugin for creating vector maps

// @material-ui/core components
import { makeStyles, withStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Typography, SvgIcon } from "@material-ui/core";

// @material-ui/icons
// import ContentCopy from "@material-ui/icons/ContentCopy";
// import InfoOutline from "@material-ui/icons/InfoOutline";

// core components
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import CardBody from "components/Card/CardBody";
import CardFooter from "components/Card/CardFooter";

import UserDetails from "./User/UserDetails";

import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import AccountCircleRoundedIcon from "@material-ui/icons/AccountCircleRounded";
import SupervisedUserCircleIcon from "@material-ui/icons/SupervisedUserCircle";
import GroupRoundedIcon from "@material-ui/icons/GroupRounded";
import { ReactComponent as Cog } from "assets/icons/cog.svg";
import { ReactComponent as Module } from "assets/icons/modicon.svg";

import styles from "assets/jss/elite-feats-cms/views/dashboardStyle";
import UserTable from "./UserTable";
import ClientsTable from "./ClientsTable";
import GroupsTable from "./GroupsTable";
import axios from "axios";
import PersonIcon from "@material-ui/icons/Person";
import ClipLoader from "react-spinners/FadeLoader";
import { css } from "@emotion/react";
import TextField from "@material-ui/core/TextField";

const useStyles = makeStyles(styles);
const TField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "#1dc0d4",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#007e8d",
    },
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: "#1dc0d4",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#1dc0d4",
      },
    },
  },
})(TextField);

const TField2 = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "#63ac1d",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#3c9778",
    },
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: "#63ac1d",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#63ac1d",
      },
    },
  },
})(TextField);

const TField3 = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "#ffa05a",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#ca5600",
    },
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: "#ffa05a",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#ffa05a",
      },
    },
  },
})(TextField);

export default function Dashboard(): React.ReactElement {
  const [users, setUsers] = React.useState<Record<string, unknown>[]>([]);
  const [clients, setClients] = React.useState<Record<string, unknown>[]>([]);
  const [groups, setGroups] = React.useState<Record<string, unknown>[]>([]);
  const [currentUser, setCurrentUser] = React.useState<Record<string, unknown>>({});
  const [openUser, setOpenUser] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [userFilter, setUserFilter] = React.useState("");
  const [clientFilter, setClientFilter] = React.useState("");
  const [groupFilter, setGroupFilter] = React.useState("");
  const [reload, setReload] = React.useState(0);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  React.useEffect(() => {
    setLoading(true);
    axios
      .get<{
        users: Record<string, unknown>[];
        clients: Record<string, unknown>[];
        groups: Record<string, unknown>[];
      }>("/api/user/admin-details", {
        headers: {
          "auth-token": localStorage.getItem("token"),
        },
      })
      .then((res) => {
        setLoading(false);
        setUsers(res.data.users);
        setClients(res.data.clients);
        setGroups(res.data.groups);
      });
  }, [reload]);
  const openUserDetails = (user: Record<string, unknown>) => {
    setCurrentUser(user);
    setOpenUser(true);
  };
  const ModuleIcon = () => (
    <SvgIcon style={{ fontSize: 36 }} component={Module} />
  );
  const ToolIcon = () => <SvgIcon style={{ fontSize: 36 }} component={Cog} />;
  const classes = useStyles() as Record<string, string>;
  const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
  `;

  const filterUsers = (filter: string) => {
    let filtered = users.filter(
      (entry) =>
        (entry.first_name as string).toLowerCase().includes(filter.toLowerCase()) ||
        (entry.last_name as string).toLowerCase().includes(filter.toLowerCase()) ||
        (entry.username as string).toLowerCase().includes(filter.toLowerCase())
    );

    return filtered;
  };

  const filterClients = (filter: string) => {
    let filtered = clients.filter(
      (entry) =>
        (entry.first_name as string).toLowerCase().includes(filter.toLowerCase()) ||
        (entry.last_name as string).toLowerCase().includes(filter.toLowerCase()) ||
        (entry.email as string).toLowerCase().includes(filter.toLowerCase()) ||
        (entry.user as string).toLowerCase().includes(filter.toLowerCase()) ||
        (entry.groups as unknown[]).join(" ").toLowerCase().includes(filter.toLowerCase())
    );

    return filtered;
  };

  const filterGroups = (filter: string) => {
    let filtered = groups.filter(
      (entry) =>
        (entry.name as string).toLowerCase().includes(filter.toLowerCase()) ||
        (entry.user as string).toLowerCase().includes(filter.toLowerCase()) ||
        (entry.description as string).toLowerCase().includes(filter.toLowerCase())
    );

    return filtered;
  };

  return (
    <div>
      <GridContainer style={{ justifyContent: "center" }}>
        <GridItem xs={12} sm={6} md lg>
          <Card>
            <CardHeader
              color="info"
              stats
              icon
              style={{
                display: "flex",
                justifyContent: "center",
                marginRight: 0,
              }}
            >
              <CardIcon color="info">
                <PersonOutlineIcon />
              </CardIcon>
            </CardHeader>
            <Typography className={classes.adminTitle} style={{ fontSize: 22 }}>
              Users
            </Typography>{" "}
            {loading ? (
              <React.Fragment>
                <ClipLoader
                  color={"#398bd6"}
                  loading={loading}
                  css={override}
                />{" "}
              </React.Fragment>
            ) : (
              <Typography
                className={classes.cardTitle}
                style={{ fontSize: 25, padding: 0, color: "#7c828b" }}
              >
                {users.length}
              </Typography>
            )}
            <CardFooter style={{ marginTop: 10 }} stats></CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md lg>
          <Card>
            <CardHeader
              color="success"
              stats
              icon
              style={{
                display: "flex",
                justifyContent: "center",
                marginRight: 0,
              }}
            >
              <CardIcon color="success">
                <AccountCircleRoundedIcon />
              </CardIcon>
            </CardHeader>

            <Typography className={classes.adminTitle} style={{ fontSize: 22 }}>
              Clients
            </Typography>
            {loading ? (
              <React.Fragment>
                <ClipLoader
                  color={"#398bd6"}
                  loading={loading}
                  css={override}
                />{" "}
              </React.Fragment>
            ) : (
              <Typography
                className={classes.cardTitle}
                style={{ fontSize: 25, padding: 0, color: "#7c828b" }}
              >
                {clients.length}
              </Typography>
            )}

            <CardFooter style={{ marginTop: 10 }} stats></CardFooter>
          </Card>
        </GridItem>{" "}
        <GridItem xs={12} sm={6} md lg>
          <Card>
            <CardHeader
              color="warning"
              stats
              icon
              style={{
                display: "flex",
                justifyContent: "center",
                marginRight: 0,
              }}
            >
              <CardIcon color="warning">
                <GroupRoundedIcon />
              </CardIcon>
            </CardHeader>

            <Typography className={classes.adminTitle} style={{ fontSize: 22 }}>
              Groups
            </Typography>
            {loading ? (
              <React.Fragment>
                <ClipLoader
                  color={"#398bd6"}
                  loading={loading}
                  css={override}
                />{" "}
              </React.Fragment>
            ) : (
              <Typography
                className={classes.cardTitle}
                style={{ fontSize: 25, padding: 0, color: "#7c828b" }}
              >
                {groups.length}
              </Typography>
            )}
            <CardFooter style={{ marginTop: 10 }} stats></CardFooter>
          </Card>
        </GridItem>{" "}
      </GridContainer>
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="info" style={{ padding: 0 }}>
              {" "}
              <h4
                style={{
                  color: "#fff",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: 350,
                  fontSize: 21,
                }}
              >
                <PersonIcon style={{ marginRight: 10 }} />
                All Users
              </h4>
            </CardHeader>
            <CardBody
              style={{
                display: "flex",
                justifyContent: "flex-end",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  maxWidth: 500,
                  marginBottom: 10,
                  width: "100%",
                  paddingLeft: 20,
                }}
              >
                <TField
                  className="search"
                  variant="outlined"
                  margin="normal"
                  id="search_text"
                  label="Search"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setUserFilter(e.target.value);
                  }}
                  fullWidth
                />
              </div>
              <UserTable
                data={filterUsers(userFilter)}
                setUser={openUserDetails}
                setReload={setReload}
                loading={loading}
                isMobile={isMobile}
              />
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="success" style={{ padding: 0 }}>
              {" "}
              <h4
                style={{
                  color: "#fff",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: 350,
                  fontSize: 21,
                }}
              >
                <AccountCircleRoundedIcon style={{ marginRight: 10 }} />
                All Clients
              </h4>
            </CardHeader>
            <CardBody
              style={{
                display: "flex",
                justifyContent: "flex-end",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  maxWidth: 500,
                  marginBottom: 10,
                  width: "100%",
                  paddingLeft: 20,
                }}
              >
                <TField2
                  className="search"
                  variant="outlined"
                  margin="normal"
                  id="search_text"
                  label="Search"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setClientFilter(e.target.value);
                  }}
                  fullWidth
                />
              </div>
              <ClientsTable
                data={filterClients(clientFilter)}
                isMobile={isMobile}
              />
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="warning" style={{ padding: 0 }}>
              {" "}
              <h4
                style={{
                  color: "#fff",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: 350,
                  fontSize: 21,
                }}
              >
                <SupervisedUserCircleIcon style={{ marginRight: 10 }} />
                All Groups
              </h4>
            </CardHeader>
            <CardBody
              style={{
                display: "flex",
                justifyContent: "flex-end",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  maxWidth: 500,
                  marginBottom: 10,
                  width: "100%",
                  paddingLeft: 20,
                }}
              >
                <TField3
                  className="search"
                  variant="outlined"
                  margin="normal"
                  id="search_text"
                  label="Search"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setGroupFilter(e.target.value);
                  }}
                  fullWidth
                />
              </div>
              <GroupsTable
                data={filterGroups(groupFilter)}
                isMobile={isMobile}
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>

      <UserDetails user={currentUser} open={openUser} setOpen={setOpenUser} />
    </div>
  );
}
